import React from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethodTransfer = ({ navigation }) => {
    return (
        <>
            <HeaderDefault title={"Escolha a forma"} />

            <View style={styles.content}>
                <View style={styles.contentList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate({ name: "SearchUsers", params: { "page":"ConfirmSearchUser" } })}>
                        <Image style={[styles.iconInfo, { width: 28, height: 20 }]} source={require('../../../assets/imgs/search.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Buscar</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Transfira seus ativos para outro usuário diretamente pelo app.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("SelectPixKey")}>
                        <Image style={[styles.iconInfo, { width: 28, height: 28 }]} source={require('../../../assets/imgs/pix.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Pix</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Transfira seus ativos através do PIX.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("MyBalance")}>
                        <Image style={[styles.iconInfo, { width: 28, height: 23 }]} source={require('../../../assets/bank.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Conta bancária</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Realize saque diretamente em conta bancária.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />
                </View>
            </View>
        </>
    )
}

export default PaymentMethodTransfer;